import { lazy } from 'react';

const HeroStoryMomentVideos = lazy(() => import('../HeroStoryMomentVideos'));

const HeroStoryMomentVideosLazy = () => {
  return <HeroStoryMomentVideos />;
};

export default HeroStoryMomentVideosLazy; 